import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'
import { StatementsProps } from './Statements.types'
import Link from 'components/shared/Link'
import { SPA_CONTRAINDICATIONS_STATEMENT } from 'constants/links'
import { StatementsWrapper } from './Statements.styles'
import Checkbox from 'components/shared/Checkbox'

const Statements = ({ isChecked, onChange }: StatementsProps) => (
    <StatementsWrapper>
        <Checkbox
            setIsChecked={onChange}
            isChecked={isChecked}
            testId="spa-check-contraindications-statement"
        >
            <Box mt={[4, 0]}>
                <Text variant="bodySmall" color="grayscale_900">
                    <Text variant="bodySmall" color="error" as="span">
                        *
                    </Text>
                    <FormattedMessage
                        id="upsells.wellness.treatment_contraindications_statement"
                        defaultMessage="Oświadczam, że korzystający z zabiegu nie ma do niego przeciwwskazań zdrowotnych."
                    />{' '}
                    <Link
                        variant="secondary"
                        textVariant="bodySmallStrong"
                        path={SPA_CONTRAINDICATIONS_STATEMENT}
                        icon={null}
                        target="_blank"
                        shouldStopPropagation
                        isUnderlined
                        data-testid="spa-link-contraindications-statement"
                    >
                        <FormattedMessage
                            id="upsells.wellness.treatment_contraindications_statement_link"
                            defaultMessage="Pełna treść oświadczenia"
                        />
                    </Link>
                </Text>
            </Box>
        </Checkbox>
    </StatementsWrapper>
)

export default Statements
